
var SvgRenderer__prototype = SvgRenderer.prototype;